<!--
 * Created by JackCui on 2021/12/13
 -->

<script>
import Pagination from './pagination.vue'
import AllSelectTem from './all-select.vue'
import {tableProps} from './index.js'

export default {
  name: 'table',
  props: tableProps,
  computed: {
    dataSource () {
      const pagination = this.paginationOpt
      if (this.allCheck) { this.handleChangeAll(true) }
      if (this.selfPaging) {
        this.paginationOpt.total = this.data.length
        return this.data.slice(
          (pagination.page - 1) * pagination.pageSize,
          pagination.page * pagination.pageSize
        )
      }
      // if (this.data.length === 0 && pagination.page !== 1) {
      //   pagination.page = 1
      //   this.handlePageChange(this.paginationOpt)
      // }
      return this.data
    }
  },
  created () {
    if (!this.createGet || !this.fetch) return
    this.fetch()
  },
  render (h) {
    /* eslint-disable */
    const Component = this.componentName
    return (
      <div class="f-table">
        {this.renderSelectAll()}
        <Component
          ref="table"
          rowKey={this.rowKey}
          groupKey={this.groupKey}
          border={true}
          estimatedRowHeight={390}
          v-on={this.$listeners}
          v-bind={this.$attrs}
          columns={this.columns}
          showGroupError={this.showGroupError}
          defaultExpandAll={this.defaultExpandAll}
          forceExpand={this.forceExpand}
          dataSource={this.dataSource}
          groupRowKey={this.groupRowKey}
          scopedSlots={{
            groupTitle: this.$scopedSlots.groupTitle,
            groupError: this.$scopedSlots.groupError,
            default: this.$scopedSlots.default,
            expand: this.$scopedSlots.rowExpand
          }}
          groupHeight={this.groupHeight}
        />
        <div class="fe-centre-table-pagination">
          {
            [this.renderSelectedCount(), this.renderPagination()]
          }
        </div>
      </div>
    )
  },
  methods: {
    handleChangeAll (val) {
      this.allCheck = val
      this.toggleSelection(val ? this.data : [], val)
    },
    renderSelectAll () {
      if (!this.isOpenAllCheck || this.paginationOpt.total === 0) { return }
      return <all-select-tem ref='allSelect' on-change-all={this.handleChangeAll} changeAll={this.changeAll} total={this.paginationOpt.total}/>
    },
    renderPagination () {
      const {total} = this.paginationOpt
      return (
        (!!total && this.showPaginationOpt) && <Pagination
          paginationOpt={this.paginationOpt}
          on-page-change={this.handlePageChange}
        />
      )
    },
    renderSelectedCount () {
      return (
        !!this.selectedCount && <div class="pagination-selected-count">
          已选中 <span class="font-color-error">{this.selectedCount}</span> 条数据
        </div>
      )
    },
    // 页码更改
    handlePageChange (pagination) {
      if (this.fetch) {
        return this.fetch()
      }
      this.$emit('page-change', pagination)
    },
    // // 每页条数更改
    // handleSizeChange (pagination) {
    //   if (this.fetch) {
    //     return this.fetch()
    //   }
    //   this.$emit('pageSize-change', pagination)
    // },
    toggleSelection (rows = [], flag) {
      if (rows.length === 0) {
        this.allCheck = false
        if (this.isOpenAllCheck  && this.$refs['allSelect']) {
          this.$refs['allSelect'].initAllCheck(false)
        }
        this.$refs['table'].resetSelection()
        return 
      }
      this.$refs['table'].toggleRowSelection(rows, flag)
    },
    toggleRowExpansion (rows = [], flag) {
      this.$refs['table'].toggleRowExpansion(rows, flag)
    }
  },
  components: {
    Pagination,
    AllSelectTem
  }
}
</script>

<style scoped lang="scss">
.f-table {
  width: 100%;
  background: #fff;
  overflow: hidden;
}

.fe-centre-table-pagination {
  overflow: hidden;

  & > div {
    height: 26px;
    line-height: 26px;
    margin: 24px 0;
  }

  .pagination-selected-count {
    float: left;
  }

  .pagination {
    float: right;
  }
}
</style>

